import { Flex, List } from 'antd';

import { ExportOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React from 'react';
import { FaArrowUpRightFromSquare , FaCheckDouble } from 'react-icons/fa6';
import styles from './NoticeList.less';

export type NoticeIconTabProps = {
  count?: any;
  showClear?: boolean;
  showViewMore?: boolean;
  style?: React.CSSProperties;
  title: string;
  tabKey: API.NoticeIconItemType;
  onClick?: (item: API.NoticeIconItem) => void;
  onClear?: () => void;
  emptyText?: string;
  clearText?: string;
  viewMoreText?: string;
  list: API.NoticeIconItem[];
  onViewMore?: (e: any) => void;
  onItemRead?: (item: API.NoticeIconItem) => void;
};
const NoticeList: React.FC<NoticeIconTabProps> = ({
  list = [],
  onClick,
  onClear,
  title,
  onViewMore,
  emptyText,
  showClear = true,
  clearText,
  viewMoreText,
  onItemRead,
  showViewMore = false,
  count,
}) => {
  if (!list || list.length === 0) {
    return (
      <div className={styles.notFound}>
        {/* <img
          src="https://gw.alipayobjects.com/zos/rmsportal/sAuJeJzSKbUmHfBQRzmZ.svg"
          alt="not found"
        />*/}
        <div>{emptyText}</div>
      </div>
    );
  }
  // @ts-ignore
  return (
    <div>
      <List<API.NoticeIconItem>
        className={styles.list}
        dataSource={list}
        renderItem={(item, i) => {
          const itemCls = classNames(styles.item, {
            [styles.read]: item.read,
          });
          // eslint-disable-next-line no-nested-ternary
          // const leftIcon = item.avatar ? (
          //   typeof item.avatar === 'string' ? (
          //     <>
          //       <UserComp key={new Date().toString()} userId={item?.userId} onlyAvatar={true} />
          //     </>
          //   ) : (
          //     <span className={styles.iconElement}>{item.avatar}</span>
          //   )
          // ) : null;
          const leftIcon = (
            <div className={styles.unread_dot_container}>
              <div className={item.read ? null : styles.unread_dot}></div>
            </div>
          );

          return (
            <List.Item
              className={itemCls}
              key={item.key || i}
              // onClick={() => {
              //   onClick?.(item);
              // }}
            >
              <List.Item.Meta
                className={styles.meta}
                avatar={leftIcon}
                title={
                  <div className={styles.title}>
                    <Flex gap={12} justify='space-between'>
                      <div>{item.title}</div>
                      {item?.referenceId && (
                        <div onClick={() => onClick(item)} className={styles.viewLead}>
                          <FaArrowUpRightFromSquare id='view_lead_notification'/>
                        </div>
                      )}
                    </Flex>

                    <div className={styles.extra}>{item.extra}</div>
                  </div>
                }
                description={
                  <div>
                    <div className={styles.description}>{item.description}</div>
                    <Flex gap={14} justify='space-between'>
                      <div className={styles.datetime}>{item.datetime}</div>

                      <div onClick={() => onItemRead(item)}>
                       <div> <FaCheckDouble className={styles.readBtn} /></div>
                      </div>
                    </Flex>
                  </div>
                }
              />
            </List.Item>
          );
        }}
      />
      <div className={styles.bottomBar}>
        {count > 0 && (
          <div>
            {showClear ? (
              <div onClick={onClear}>
                <p className={styles.bottomText}>
                  <FaCheckDouble className={styles.icons} /> {clearText}{' '}
                  {count > 0 ? `${count}` : count} {title}
                </p>
              </div>
            ) : null}
          </div>
        )}
        {showViewMore ? (
          <div
            onClick={(e) => {
              if (onViewMore) {
                onViewMore(e);
              }
            }}
          >
            <ExportOutlined /> {viewMoreText}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default NoticeList;
